var _path, _path2, _g, _ellipse, _path3, _path4, _path5, _path6, _ellipse2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashHistory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 66,
    viewBox: "0 0 120 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3833 39.9128C26.0295 39.148 20.9626 33.9589 17.567 29.3038C15.8744 26.9833 12.3333 26.6477 10.5008 28.8593L3.40924 37.4181C2.2017 38.8755 2.16337 40.977 3.42526 42.3876C7.57769 47.0293 15.2754 54.2777 24.2093 58.7446C33.042 63.1609 41.0691 63.4489 45.5632 62.8317C47.0633 62.6257 48.1419 61.3943 48.4101 59.9041L51.0416 45.2847C51.5223 42.6142 49.2802 40.2134 46.5707 40.3568C42.1465 40.591 36.366 40.6247 31.3833 39.9128Z",
    fill: "url(#paint0_linear_2810_19973)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3833 39.9128C26.0295 39.148 20.9626 33.9589 17.567 29.3038C15.8744 26.9833 12.3333 26.6477 10.5008 28.8593L3.40924 37.4181C2.2017 38.8755 2.16337 40.977 3.42526 42.3876C7.57769 47.0293 15.2754 54.2777 24.2093 58.7446C33.042 63.1609 41.0691 63.4489 45.5632 62.8317C47.0633 62.6257 48.1419 61.3943 48.4101 59.9041L51.0416 45.2847C51.5223 42.6142 49.2802 40.2134 46.5707 40.3568C42.1465 40.591 36.366 40.6247 31.3833 39.9128Z",
    fill: "black",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6927 41.9124C25.3389 41.1475 20.272 35.9584 16.8765 31.3033C15.1838 28.9828 11.6428 28.6472 9.81025 30.8588L2.71869 39.4176C1.51115 40.875 1.47282 42.9765 2.73471 44.3871C6.88714 49.0289 14.5849 56.2772 23.5187 60.7441C32.3514 65.1604 40.3785 65.4484 44.8727 64.8312C46.3727 64.6252 47.4513 63.3938 47.7196 61.9036L50.351 47.2842C50.8317 44.6137 48.5897 42.2129 45.8801 42.3563C41.456 42.5905 35.6754 42.6242 30.6927 41.9124Z",
    fill: "url(#paint1_linear_2810_19973)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6927 41.9124C25.3389 41.1475 20.272 35.9584 16.8765 31.3033C15.1838 28.9828 11.6428 28.6472 9.81025 30.8588L2.71869 39.4176C1.51115 40.875 1.47282 42.9765 2.73471 44.3871C6.88714 49.0289 14.5849 56.2772 23.5187 60.7441C32.3514 65.1604 40.3785 65.4484 44.8727 64.8312C46.3727 64.6252 47.4513 63.3938 47.7196 61.9036L50.351 47.2842C50.8317 44.6137 48.5897 42.2129 45.8801 42.3563C41.456 42.5905 35.6754 42.6242 30.6927 41.9124Z",
    fill: "black",
    fillOpacity: 0.1
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.227,
    cy: 49.1942,
    rx: 4.70794,
    ry: 3.45249,
    fill: "#DFEBEA",
    fillOpacity: 0.48
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2769 36.8202C85.0549 35.4135 78.3532 38.1861 73.398 41.1265C70.928 42.5922 67.5411 41.5054 66.7284 38.7506L63.5832 28.0898C63.0477 26.2745 63.8406 24.3279 65.5562 23.5287C71.2017 20.8988 81.1328 17.2703 91.1041 16.6852C100.962 16.1068 108.453 19.0053 112.341 21.3434C113.638 22.1238 114.144 23.6807 113.804 25.156L110.461 39.6294C109.851 42.2732 106.844 43.5963 104.41 42.3968C100.436 40.4382 95.1369 38.1294 90.2769 36.8202Z",
    fill: "url(#paint2_linear_2810_19973)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2769 36.8202C85.0549 35.4135 78.3532 38.1861 73.398 41.1265C70.928 42.5922 67.5411 41.5054 66.7284 38.7506L63.5832 28.0898C63.0477 26.2745 63.8406 24.3279 65.5562 23.5287C71.2017 20.8988 81.1328 17.2703 91.1041 16.6852C100.962 16.1068 108.453 19.0053 112.341 21.3434C113.638 22.1238 114.144 23.6807 113.804 25.156L110.461 39.6294C109.851 42.2732 106.844 43.5963 104.41 42.3968C100.436 40.4382 95.1369 38.1294 90.2769 36.8202Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6877 33.7001C83.4657 32.2933 76.764 35.0659 71.8088 38.0064C69.3387 39.4721 65.9519 38.3853 65.1391 35.6304L61.994 24.9697C61.4584 23.1544 62.2513 21.2078 63.967 20.4086C69.6125 17.7787 79.5436 14.1502 89.5148 13.5651C99.3731 12.9867 106.864 15.8851 110.752 18.2233C112.049 19.0037 112.555 20.5605 112.214 22.0358L108.872 36.5093C108.262 39.1531 105.255 40.4762 102.821 39.2767C98.8472 37.3181 93.5477 35.0093 88.6877 33.7001Z",
    fill: "url(#paint3_linear_2810_19973)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6877 33.7001C83.4657 32.2933 76.764 35.0659 71.8088 38.0064C69.3387 39.4721 65.9519 38.3853 65.1391 35.6304L61.994 24.9697C61.4584 23.1544 62.2513 21.2078 63.967 20.4086C69.6125 17.7787 79.5436 14.1502 89.5148 13.5651C99.3731 12.9867 106.864 15.8851 110.752 18.2233C112.049 19.0037 112.555 20.5605 112.214 22.0358L108.872 36.5093C108.262 39.1531 105.255 40.4762 102.821 39.2767C98.8472 37.3181 93.5477 35.0093 88.6877 33.7001Z",
    fill: "black",
    fillOpacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.70794,
    cy: 3.45249,
    rx: 4.70794,
    ry: 3.45249,
    transform: "matrix(0.919088 0.394053 0.394053 -0.919088 83.5076 27.5762)",
    fill: "#DFEBEA",
    fillOpacity: 0.48
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2810_19973",
    x1: 11.7519,
    y1: 24.2197,
    x2: 45.0369,
    y2: 72.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2810_19973",
    x1: 11.0613,
    y1: 26.2192,
    x2: 44.3464,
    y2: 74.8455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2810_19973",
    x1: 66.05,
    y1: 43.5077,
    x2: 115.803,
    y2: 11.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2810_19973",
    x1: 64.4608,
    y1: 40.3876,
    x2: 114.214,
    y2: 8.81187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026051"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B5F59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A092"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashHistory);
export default __webpack_public_path__ + "static/media/cashHistory.f378917f8efabced47c468f0030ec1d7.svg";
export { ForwardRef as ReactComponent };